/**
 * Returns the 1- or 2-character avatar initials for a customer/tenant name.
 *
 * Mirrors the logic used by the customer page header avatar:
 *   - First character of the name (any character, kept as-is).
 *   - First character of the last whitespace-separated word, but only when
 *     it is an ASCII letter; otherwise the trailing initial is omitted.
 *
 * Examples:
 *   "Microsoft"                     -> "M"
 *   "Tata Consultancy Services Ltd" -> "TL"
 *   "PwC"                           -> "P"
 *   "AT&T Inc."                     -> "A"   (last word "Inc." starts with a letter -> "AI")
 */
export function getCustomerInitials(name?: string | null): string {
  const _name = (name ?? "").trim();
  if (!_name) return "";
  const first = _name.charAt(0);
  const idx = _name.lastIndexOf(" ");
  const lastInitialRaw = _name.charAt(idx > 0 ? idx + 1 : idx);
  const lastInitial = lastInitialRaw.match(/^[a-z]/i) ? lastInitialRaw : "";
  return first + lastInitial;
}
